<template>
    <tr>
        <td width="20%">
            <a class="showcase-link" :href="showcaseLink" target="_blank">
                <div class="preview-icon"><i class='las la-eye'></i><br/>{{$t('views.showcases.preview')}}</div>
                <img class="img-rounded img-responsive" :src="'https://i.vimeocdn.com/video/' + showcase.first_picture + '-' + showcase.first_picture_key +'-d_300x180'">
            </a>
        </td>
        <td>
            <h5 class="margin-bottom-5">{{showcase.title}}</h5>
            <span v-if="showcase.privacy === SHOWCASE_PRIVACY.NOT_VISIBLE" class="label label-warning">{{$t('common.not_public')}}</span>
            <span v-else class="label label-success">{{$t('common.public')}}</span>
        </td>
        <td>{{getDataExtendString(showcase.created_date)}}</td>
        <td class="text-right">
            <router-link  class="btn btn-default" :to="{ name: 'showcase_detail', params: { showcase_id: showcase.id }}">
                <i class="las la-edit"></i>{{ $t('common.edit') }}
            </router-link>
        </td>
    </tr>

</template>

<script>

    import {SHOWCASE_PRIVACY, URL_SHOWCASE, VIDEO_STATE} from "../../common/constants";
import {Utils} from "../../common/utils";

export default {
	name: "VideoRow",
	props: {
		showcase: {
			type: Object,
			require: true
		}
	},
    data: () => {
        return {
            VIDEO_STATE: VIDEO_STATE,
            SHOWCASE_PRIVACY: SHOWCASE_PRIVACY
        }
    },
    computed: {
        showcaseLink() {
            return URL_SHOWCASE + this.showcase.fingerprint
        }
    },
    methods: {
        getDataExtendString(date){
            return Utils.getDateStringFromISO(date)
        },
        getDurationTime(seconds) {
            return Utils.getDurationTime(seconds)
        },
        getStringPrivacyShowcase(privacy) {
            return Utils.getStringPrivacyShowcase(privacy)
        }
    }
};
</script>
